/**
 * Returns a date string without the timezoneoffset
 *
 * @param a date string
 * @returns a date string with no timezoneoffset
 *
 * exmaple:
 * param '2024-02-17T12:30:00-06:00'
 * returns: '2024-02-17T12:30:00'
 *
 */
export const trimTimeZoneOffset = (date?: string | null) => {
	return date?.slice(0, 19) ?? '';
};
